import React from 'react';
import { Field as FormikField, FieldProps, useFormikContext } from 'formik';
import { useQuery } from '@apollo/react-hooks';
import { Option, Select } from '@xo-union/tk-component-fields';
import Spinner from '@xo-union/tk-component-spinner';
import dateTimeFormatted, { defaultFormat } from './helpers/dateTimeFormatted';
import { eventsQuery } from './graphql';
import { DateFormInitialVal } from './types';
import styles from './styles.scss';

export const formats = ['range', 'short', 'natural', 'weekday', 'verbose', 'ornate'];

const WeddingDateFormat: React.FC = () => {
  const { data: eventsData, loading: eventsLoading } = useQuery(eventsQuery);
  const { values } = useFormikContext();

  const { date: weddingDate } = values as DateFormInitialVal;
  const weddingDayTime = eventsData?.events.find((e: any) => e.type === 'WeddingDay')?.time;

  const defaultDate = React.useMemo(() => {
    const newDate = new Date(Date.now());
    newDate.setFullYear(newDate.getFullYear() + 1);
    return newDate;
  }, []);
  let date = weddingDate;
  if (date && weddingDayTime) {
    date = `${weddingDate} ${weddingDayTime}`;
  }

  const formatOptions = formats.map(f => [f, dateTimeFormatted(date || defaultDate, f)]);

  if (eventsLoading) return <Spinner data-testid="format-spinner" />;
  return (
    <FormikField name="format" label="Display Format">
      {({ field: { name, value }, form: { setFieldValue } }: FieldProps): React.ReactElement => {
        return (
          <span className={styles.dateFormatDropdown}>
            <Select
              name={name}
              value={value || defaultFormat}
              data-testid="wedding-date-format"
              label="Display Format"
              onChange={({ option }: any): void => setFieldValue(name, option.value)}
            >
              {formatOptions.map(([key, val]) => (
                <Option value={key} key={key} data-testid={`date-option-${key}`}>
                  {val}
                </Option>
              ))}
            </Select>
          </span>
        );
      }}
    </FormikField>
  );
};

export default WeddingDateFormat;
